<div class="welcome-wrap">
  <div class="wrap-openpay-logo">
    <img src="./assets/img/logo/openpay.webp"
         srcset="./assets/img/logo/openpay@2x.webp 2x,
             ./assets/img/logo/openpay@3x.webp 3x"
         class="openpay-logo"
         alt="openpay logo"
    >
  </div>

  <div class="welcome-main-container">

    <div class="card-container">

      <div class="information-container">

        <div class="info-description">
          <p>
            Al integrar la pasarela de pago Openpay, podrás recibir pagos en tu tienda en línea.
          </p>
          <br>
          <p>
            <strong>Si aún no tienes cuenta en Openpay:</strong>
          </p>
          <table>
            <tr>
              <td><img src="./assets/img/welcome-assets/welcome-vineta.png" width="30px"></td>
              <td>Ingresa a Openpay y <span class="text-link" (click)="goToRegister()">registra tu negocio</span>.</td>
            </tr>
          </table>
          <br>
          <p>
            <strong>Si ya tienes cuenta en Openpay:</strong>
          </p>
          <table>
            <tr>
              <td><img src="./assets/img/welcome-assets/welcome-vineta.png" width="30px"></td>
              <td>Asegúrate de tener tu cuenta en modo productivo para que puedas recibir pagos y hacer transacciones reales.</td>
            </tr>
            <tr></tr>
            <tr></tr>
            <tr></tr>
            <tr>
              <td><img src="./assets/img/welcome-assets/welcome-vineta.png" width="30px"></td>
              <td>Usa el correo y contraseña de tu cuenta en modo productivo para continuar.</td>
            </tr>
          </table>
        </div>

        <div class="button-container">
          <div class="buttons-position">
            <Openpay-basic-simple-button (click)="goToRegister()">Registrar negocio</Openpay-basic-simple-button>
            <Openpay-basic-button id="btn-start-login" (click)="goToCallbackUrl()">Continuar</Openpay-basic-button>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>
